import { stores } from "../../../data/stores";
export const haversineDistance = (
  coords1: { lat: number; lng: number },
  coords2: { lat: number; lng: number }
) => {
  const R = 3958.8; // Earth's radius in miles
  const lat1 = coords1.lat;
  const lon1 = coords1.lng;
  const lat2 = coords2.lat;
  const lon2 = coords2.lng;

  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in miles
};

export const threeNearestStores = (
  stores: any,
  coords: { lat: number; lng: number }
) => {
  return stores
    .map((store: any) => {
      return {
        ...store,
        distance: haversineDistance(coords, { lat: store.lat, lng: store.lng }),
      };
    })
    .sort((a: any, b: any) => a.distance - b.distance)
    .slice(0, 3);
};

export const zipSearch = async (zipcode: string) => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&key=${process.env.GOOGLE_MAPS_API_KEY}`
    );
    const data = await response.json();
    if (data.status === "OK") {
      const coords = data.results[0].geometry.location;
      return coords;
    }
  } catch (error) {
    console.log("error", error);
  }
  return {};
};

export const roundUpToNearest15Minutes = (date: Date) => {
  const ms = 1000 * 60 * 15; // 15 minutes in milliseconds
  return new Date(Math.ceil(date.getTime() / ms) * ms);
};
export const formattedTimeInUTC = (time: Date) => {
  const year = time.getUTCFullYear();
  const month = time.getUTCMonth() + 1;
  const date = time.getUTCDate();
  const hours = time.getUTCHours().toString().padStart(2, "0");
  const mins = time.getUTCMinutes().toString().padStart(2, "0");
  return `${year}/${month}/${date} ${hours}:${mins}`;
};
export const formattedTime = (time: Date) => {
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const date = time.getDate();
  const hours = time.getHours().toString().padStart(2, "0");
  const mins = time.getMinutes().toString().padStart(2, "0");
  return `${year}/${month}/${date} ${hours}:${mins}`;
};
export const formatPhoneNumber = (phoneNumber: string) => {
  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6, 10);

  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};

export const getAllDistinctStates = () => {
  const states = new Set();
  stores.forEach((store: any) => {
    states.add(store.province);
  });
  return states;
};
